/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Compare_ToggleInputs */



/**
* | output |
* | --- |
* | "Compare with previous period" |
*
* @param {Usage_Compare_ToggleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_compare_toggle = /** @type {((inputs?: Usage_Compare_ToggleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Compare_ToggleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comparer avec la période précédente")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergleich mit dem vorherigen Zeitraum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Confronta con il periodo precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("По сравнению с предыдущим периодом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comparar con el período anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("与上期相比")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前期との比較")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली अवधि से तुलना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comparar com o período anterior")
	return /** @type {LocalizedString} */ ("Compare with previous period")
});